module.exports = __webpack_public_path__ + "static/img/app-equitymate@2x.cfadfc69.png";